module.exports = __webpack_public_path__ + "img/icon-ssb.8e40c5e6.png";